import React, { ReactElement, ReactNode } from "react";

export const separateBy = (parts: ReactNode[], separator: ReactNode) =>
  parts.map((p, index) => (
    <React.Fragment key={(p as ReactElement).key ?? index}>
      {p}
      {index < parts.length - 1 && separator}
    </React.Fragment>
  ));
